/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "components/Input";
import apiService from "services/apiService";
import { capitalize } from "util/Util";
import Modal from "components/Modal";
import NoDataImage from "assets/nodata.jpg";
import NoDataDarkImage from "assets/nodata-dark.jpg";
import UploadDocs from "./UploadDocs";
import appConfig from "services/apiConfig";
import { MdDelete } from "react-icons/md";
import { useToaster } from "contexts/toasterContext";
import { useTranslation } from "react-i18next";
import GenericModal from "components/Modal";
// import DeletePopup from "components/DeletePopup/deletePopup";
// import GenericModal from "components/Modal";
// const [deleteModal, setDeleteModal] = useState(false);
// import DeletePopup from "components/DeletePopup/deletePopup";

const schema = yup.object({});

export default function GenerateDocs() {
  const [dynamicSchema, setDynamicSchema] = useState<any>(
    yup.object().shape({})
  );
  const methods = useForm({
    resolver: yupResolver(dynamicSchema), 
  });
  const [tags, setTags] = useState<string[]>([]);
  const [docId, setDocId] = useState<number | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const { reset } = methods;
  const [refresh, setRefresh] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { addToast } = useToaster();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  
  useEffect(() => {
    if (tags.length > 0) {
      const newSchema = schema.shape(
        tags.reduce((acc: any, tag: string) => {
          acc[tag] = yup.string().required(`${tag.split("::")[0]} is required`);
          return acc;
        }, {})
      );
      setDynamicSchema(newSchema);
    }
  }, [tags]);

  const fetchData = () => {
    setIsLoading(true); // Start loading
    apiService
      .get("api/documents/templates")
      .then((res) => {
        console.log("res", res.data);
        setData(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setIsLoading(false); // Stop loading regardless of success or error
      });
  };

  useEffect(() => {
    fetchData();
  }, [refresh]);

  const handleGenerateDocument = async (data: any) => {
    console.log("data==>", data);
    data.format = "docx";
    const format = "docx";
    const url = appConfig.getBaseUrl();
    const token = localStorage.getItem("accessToken");
    try {
      const queryString = new URLSearchParams(data);
      const response = await fetch(
        `${url}api/documents/generateDocument/${docId}?${queryString}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        alert(`Failed to generate document: ${errorText}`);
        return;
      }
      const contentType: any = response.headers.get("Content-Type");
      const blob = await response.blob();
      let mimeType;
      if (contentType.includes("pdf")) {
        mimeType = "application/pdf";
      } else if (contentType.includes("wordprocessingml.document")) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else {
        mimeType = "application/octet-stream";
      }

      const a = document.createElement("a");
      a.href = URL.createObjectURL(new Blob([blob], { type: mimeType }));
      a.download = `document.${format}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while generating the document.");
    }
  };

  const getTypeFromTag = (tag: string): "text" | "number" | "date" => {
    const type = tag.split("::")[1];

    switch (type) {
      case "String":
        return "text";
      case "Date":
        return "date";
      case "int":
        return "number";
      default:
        return "text";
    }
  };

  const handleTemplateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setSelectedTemplateId(selectedValue);

    const selectedDoc = data.find((doc) => doc.id === parseInt(selectedValue));
    if (selectedDoc) {
      setTags(selectedDoc.tags);
      setDocId(selectedDoc.id);
      reset();
    }
  };

  const handleDeleteDocs = () => {
    setIsDeleting(true);
    apiService
      .delete(`api/documents/${docId}`)
      .then((res) => {
        console.log("res", res);
        setTags([]);
        setDocId(null);
        setSelectedTemplateId("");
        addToast(res.data, "success");
        console.log("Datas : " + res.data, docId, res.data.id);
        fetchData();
        // setRefresh(true)
        console.log("Datas : " + res.data, docId, res.data.id);
      })
      .catch((err) => {
        console.log("err", err);
        addToast("Something Went Wrong", "error");
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  const { t } = useTranslation();

  return (
    <>
      {/* Here Adding  page path and their grid title header  */}

      {/* <BreadCrumb BreadCrumbList={BreadCrumbList}></BreadCrumb> */}

      <div className="w-full bg-white min-h-full xl:p-0 dark:bg-gray-800">
        {openModal && (
          <Modal
            isOpen={openModal}
            onClose={() => {
              setOpenModal(false);
              setTags([]);
              setDynamicSchema("");
            }}
            header="Upload Document"
          >
            <UploadDocs
              refresh={refresh}
              setRefresh={setRefresh}
              setOpenModal={setOpenModal}
            />
          </Modal>
        )}

        <div>
          <div className="p-2 space-y-4 md:space-y-6 ">
            <div className="flex items-center justify-between">
              <h2 className="block text-xl font-medium text-gray-800 dark:text-gray-300">
                {t("Generate Docs")}
              </h2>
              <button
                className="w-300 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white  bg-blue-700 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={!selectedTemplateId}
                onClick={() => {
                  setOpenModal(true);
                  setDynamicSchema(schema);
                  setTags([]);
                }}
              >
                {`${t("Upload")} ${t("Document")}`}
              </button>
            </div>
            <hr className="dark:border-gray-700 mb-2" />
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "66%" }}>
                <div className="center">
                  <div style={{ maxWidth: 540 }}>
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {t("Select A Document Template")}
                    </label>
                    <select
                      className={`block w-full bg-white dark:bg-gray-700 p-2 mb-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${
                        selectedTemplateId
                          ? "text-gray-900 dark:text-white"
                          : "text-slate-400 dark:text-gray-400"
                      }`}
                      onChange={handleTemplateChange}
                      value={selectedTemplateId}
                    >
                      {isLoading ? (
                        <option value="" disabled className="text-slate-400 dark:text-gray-400">
                          {t("Loading documents...")}
                        </option>
                      ) : data && data.length > 0 ? (
                        <>
                          <option
                            value=""
                            disabled
                            hidden
                            aria-hidden="true"
                            style={{ display: "none" }}
                            className="text-slate-400 dark:text-gray-400"
                          >
                            {t("Select A Document Template")}
                          </option>
                          {data.map((doc: any) => (
                            <option
                              key={doc.id}
                              value={doc.id}
                              className="text-gray-900 dark:text-white"
                            >
                              {doc.documentName}
                            </option>
                          ))}
                        </>
                      ) : (
                        <option value="" disabled className="text-slate-400 dark:text-gray-400">
                          {t("No document is available")}
                        </option>
                      )}
                    </select>
                  </div>
                  {docId && (
                    <div
                      className="flex items-center justify-between p-2 m-1 mt-3  bg-gray-100 rounded-lg shadow-md"
                      style={{ margin: "8px", marginTop: "24px" }}
                    >
                      <button
                        onClick={() => setConfirmDelete(true)}
                        disabled={isDeleting}
                        className="ml-4 text-red-500 hover:text-red-700 focus:outline-none"
                        aria-label="Delete"
                      >
                        <MdDelete size={24} />
                      </button>
                    </div>
                  )}

                  {confirmDelete && (
                    <GenericModal
                      isOpen={confirmDelete}
                      onClose={() => setConfirmDelete(false)}
                      header="Confirm Delete"
                    >
                      <div className="p-4 relative ">
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                          Are you sure you want to delete this document?
                        </h3>
                        <div className="flex justify-end mt-4">
                          <button
                            onClick={() => {
                              handleDeleteDocs();
                              setConfirmDelete(false); // Close modal after confirming
                            }}
                            className="text-white absolute left-0 bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
                          >
                            Yes, I am sure
                          </button>
                          <button
                            onClick={() => setConfirmDelete(false)} // Close modal on cancel
                            className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                          >
                            No, cancel
                          </button>
                        </div>
                      </div>
                    </GenericModal>
                  )}
                </div>
                {tags && tags.length > 0 ? (
                  <FormProvider {...methods}>
                    <form
                      onSubmit={methods.handleSubmit(handleGenerateDocument)}
                      className="center"
                    >
                      <div
                        style={{ maxWidth: 540 }}
                        className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700 p-6 space-y-4 md:space-y-6 sm:p-8"
                      >
                        {tags.map((tag: any) => (
                          <Input
                            key={tag}
                            name={tag}
                            label={capitalize(tag.split("::")[0])}
                            required
                            placeholder={`Please enter ${tag.split("::")[0]}`}
                            type={getTypeFromTag(tag)}
                          />
                        ))}
                        <div className="mt-6">
                          <button
                            type="submit"
                            className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          >
                            Generate Document
                          </button>
                        </div>
                      </div>
                    </form>
                  </FormProvider>
                ) : (
                  <div className="center">
                    <img
                      src={NoDataImage}
                      height={300}
                      width={400}
                      alt="No data"
                      className="dark:hidden"
                    />
                    <img
                      src={NoDataDarkImage}
                      height={300}
                      width={400}
                      alt="No data"
                      className="hidden dark:block"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}